import type { DateRange } from '../types';

interface DashboardHeaderProps {
  dateRange: DateRange;
  onDateRangeChange: (range: DateRange) => void;
}

function formatInputDate(isoDate: string): string {
  // Ensure yyyy-mm-dd for date input value
  const date = new Date(isoDate);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function DashboardHeader({ dateRange, onDateRangeChange }: DashboardHeaderProps) {
  return (
    <header className="mb-6 flex flex-col gap-4 sm:mb-8 lg:flex-row lg:items-start lg:justify-between">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">Risk Monitoring Dashboard</h1>
        <p className="text-sm text-gray-500">
          Last updated: {new Date('2026-08-06T00:00:00Z').toLocaleString()}
        </p>
      </div>

      <div
        className="flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-3 shadow-sm sm:flex-row sm:items-center"
        aria-label="Date range filter"
      >
        <span className="text-sm font-medium text-gray-700">Date range</span>
        <div className="flex items-center gap-2">
          <label htmlFor="date-start" className="sr-only">
            Start date
          </label>
          <input
            id="date-start"
            type="date"
            value={formatInputDate(dateRange.start)}
            onChange={(e) =>
              onDateRangeChange({ ...dateRange, start: e.target.value })
            }
            className="rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-700 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            aria-label="Start date"
          />
          <span className="text-sm text-gray-400">→</span>
          <label htmlFor="date-end" className="sr-only">
            End date
          </label>
          <input
            id="date-end"
            type="date"
            value={formatInputDate(dateRange.end)}
            onChange={(e) =>
              onDateRangeChange({ ...dateRange, end: e.target.value })
            }
            className="rounded-md border border-gray-300 px-2 py-1.5 text-sm text-gray-700 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            aria-label="End date"
          />
        </div>
      </div>
    </header>
  );
}
